import { create } from 'zustand';

export type AuthMode = 'anonymous' | 'authenticated';
export type AuthProvider = 'google' | 'apple' | null;

export interface AuthStoreState {
  uid: string | null;
  authMode: AuthMode;
  displayName: string | null;
  email: string | null;
  provider: AuthProvider;
  setAuthenticated: (info: {
    uid: string;
    displayName: string | null;
    email: string | null;
    provider: 'google' | 'apple';
  }) => void;
  setAnonymous: () => void;
}

export const useAuthStore = create<AuthStoreState>()((set) => ({
  uid: null,
  authMode: 'anonymous',
  displayName: null,
  email: null,
  provider: null,
  setAuthenticated: ({ uid, displayName, email, provider }) =>
    set({ uid, authMode: 'authenticated', displayName, email, provider }),
  setAnonymous: () =>
    set({ uid: null, authMode: 'anonymous', displayName: null, email: null, provider: null }),
}));
